var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/generated/console-api-graph/graphql.ts
var graphql_exports = {};
__export(graphql_exports, {
  GetBrandDocument: () => GetBrandDocument,
  GetBrandsListDocument: () => GetBrandsListDocument,
  GetTeamsListDocument: () => GetTeamsListDocument,
  GetUserFontsDocument: () => GetUserFontsDocument,
  getSdk: () => getSdk
});

// ../../node_modules/tslib/tslib.es6.mjs
var __assign = function() {
  __assign = Object.assign || function __assign2(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p))
          t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};

// ../../node_modules/graphql-tag/lib/index.js
import { parse } from "graphql";
var docCache = /* @__PURE__ */ new Map();
var fragmentSourceMap = /* @__PURE__ */ new Map();
var printFragmentWarnings = true;
var experimentalFragmentVariables = false;
function normalize(string) {
  return string.replace(/[\s,]+/g, " ").trim();
}
function cacheKeyFromLoc(loc) {
  return normalize(loc.source.body.substring(loc.start, loc.end));
}
function processFragments(ast) {
  var seenKeys = /* @__PURE__ */ new Set();
  var definitions = [];
  ast.definitions.forEach(function(fragmentDefinition) {
    if (fragmentDefinition.kind === "FragmentDefinition") {
      var fragmentName = fragmentDefinition.name.value;
      var sourceKey = cacheKeyFromLoc(fragmentDefinition.loc);
      var sourceKeySet = fragmentSourceMap.get(fragmentName);
      if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
        if (printFragmentWarnings) {
          console.warn("Warning: fragment with name " + fragmentName + " already exists.\ngraphql-tag enforces all fragment names across your application to be unique; read more about\nthis in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
        }
      } else if (!sourceKeySet) {
        fragmentSourceMap.set(fragmentName, sourceKeySet = /* @__PURE__ */ new Set());
      }
      sourceKeySet.add(sourceKey);
      if (!seenKeys.has(sourceKey)) {
        seenKeys.add(sourceKey);
        definitions.push(fragmentDefinition);
      }
    } else {
      definitions.push(fragmentDefinition);
    }
  });
  return __assign(__assign({}, ast), { definitions });
}
function stripLoc(doc) {
  var workSet = new Set(doc.definitions);
  workSet.forEach(function(node) {
    if (node.loc)
      delete node.loc;
    Object.keys(node).forEach(function(key) {
      var value = node[key];
      if (value && typeof value === "object") {
        workSet.add(value);
      }
    });
  });
  var loc = doc.loc;
  if (loc) {
    delete loc.startToken;
    delete loc.endToken;
  }
  return doc;
}
function parseDocument(source) {
  var cacheKey = normalize(source);
  if (!docCache.has(cacheKey)) {
    var parsed = parse(source, {
      experimentalFragmentVariables,
      allowLegacyFragmentVariables: experimentalFragmentVariables
    });
    if (!parsed || parsed.kind !== "Document") {
      throw new Error("Not a valid GraphQL document.");
    }
    docCache.set(cacheKey, stripLoc(processFragments(parsed)));
  }
  return docCache.get(cacheKey);
}
function gql(literals) {
  var args = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    args[_i - 1] = arguments[_i];
  }
  if (typeof literals === "string") {
    literals = [literals];
  }
  var result = literals[0];
  args.forEach(function(arg, i) {
    if (arg && arg.kind === "Document") {
      result += arg.loc.source.body;
    } else {
      result += arg;
    }
    result += literals[i + 1];
  });
  return parseDocument(result);
}
function resetCaches() {
  docCache.clear();
  fragmentSourceMap.clear();
}
function disableFragmentWarnings() {
  printFragmentWarnings = false;
}
function enableExperimentalFragmentVariables() {
  experimentalFragmentVariables = true;
}
function disableExperimentalFragmentVariables() {
  experimentalFragmentVariables = false;
}
var extras = {
  gql,
  resetCaches,
  disableFragmentWarnings,
  enableExperimentalFragmentVariables,
  disableExperimentalFragmentVariables
};
(function(gql_1) {
  gql_1.gql = extras.gql, gql_1.resetCaches = extras.resetCaches, gql_1.disableFragmentWarnings = extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = extras.disableExperimentalFragmentVariables;
})(gql || (gql = {}));
gql["default"] = gql;
var lib_default = gql;

// src/generated/console-api-graph/graphql.ts
var GetBrandDocument = lib_default`
  query getBrand($id: ID) {
    brand(_id: $id) {
      _id
      name
      lastUpdatedBy {
        _id
        name
        teams {
          team
          manage
        }
      }
      team
      fonts
      createdBy {
        _id
        name
        teams {
          team
          manage
        }
      }
      createdAt
      backgrounds
      backgroundImageSets
      adTemplate {
        market {
          oddsButtonTemplate
        }
        potentialWinnings {
          stake
          currency
        }
        team {
          badge {
            borderColor
            filters {
              competitions
              operator
              sports
            }
            leagueLogos {
              competitions
              operator
            }
          }
          useAdditionalBrandingOptions
          useCustomAssets
          useHorseRacingSilks
          useTeamBadges
          useTeamColors
          useTeamJerseys
          useTeamBranding
        }
      }
    }
  }
`;
var GetBrandsListDocument = lib_default`
  query getBrandsList($teamId: String) {
    brands(query: { type: "social", team: $teamId }) {
      edges {
        node {
          _id
          name
        }
      }
    }
  }
`;
var GetTeamsListDocument = lib_default`
  query getTeamsList {
    teams(query: { features: { socialBrands: true } }) {
      edges {
        node {
          _id
          name
        }
      }
    }
  }
`;
var GetUserFontsDocument = lib_default`
  query getUserFonts($teamId: String) {
    userFonts(query: { team: $teamId, archived: false }) {
      edges {
        node {
          _id
          name
          family
          fontFamily
          url
        }
      }
    }
  }
`;
var defaultWrapper = (action, _operationName, _operationType) => action();
function getSdk(client, withWrapper = defaultWrapper) {
  return {
    getBrand(variables, requestHeaders) {
      return withWrapper(
        (wrappedRequestHeaders) => client.request(GetBrandDocument, variables, {
          ...requestHeaders,
          ...wrappedRequestHeaders
        }),
        "getBrand",
        "query"
      );
    },
    getBrandsList(variables, requestHeaders) {
      return withWrapper(
        (wrappedRequestHeaders) => client.request(GetBrandsListDocument, variables, {
          ...requestHeaders,
          ...wrappedRequestHeaders
        }),
        "getBrandsList",
        "query"
      );
    },
    getTeamsList(variables, requestHeaders) {
      return withWrapper(
        (wrappedRequestHeaders) => client.request(GetTeamsListDocument, variables, {
          ...requestHeaders,
          ...wrappedRequestHeaders
        }),
        "getTeamsList",
        "query"
      );
    },
    getUserFonts(variables, requestHeaders) {
      return withWrapper(
        (wrappedRequestHeaders) => client.request(GetUserFontsDocument, variables, {
          ...requestHeaders,
          ...wrappedRequestHeaders
        }),
        "getUserFonts",
        "query"
      );
    }
  };
}

// src/generated/console-api-graph/graphql.schema.ts
var graphql_schema_exports = {};
__export(graphql_schema_exports, {
  getBrandQuerySchema: () => getBrandQuerySchema,
  getBrandsListQuerySchema: () => getBrandsListQuerySchema,
  getTeamsListQuerySchema: () => getTeamsListQuerySchema,
  getUserFontsQuerySchema: () => getUserFontsQuerySchema,
  scalarsSchema: () => scalarsSchema
});
import { z } from "zod";
var scalarsSchema = z.object({
  ID: z.object({
    input: z.string(),
    output: z.string()
  }),
  String: z.object({
    input: z.string(),
    output: z.string()
  }),
  Boolean: z.object({
    input: z.boolean(),
    output: z.boolean()
  }),
  Int: z.object({
    input: z.number(),
    output: z.number()
  }),
  Float: z.object({
    input: z.number(),
    output: z.number()
  }),
  DateTime: z.object({
    input: z.any(),
    output: z.any()
  }),
  JSON: z.object({
    input: z.any(),
    output: z.any()
  })
});
var getBrandQuerySchema = z.object({
  __typename: z.literal("Query").optional(),
  brand: z.object({
    __typename: z.literal("Brand").optional(),
    _id: z.string().optional().nullable(),
    name: z.string().optional().nullable(),
    team: z.string().optional().nullable(),
    fonts: z.any().optional().nullable(),
    createdAt: z.any().optional().nullable(),
    backgrounds: z.any().optional().nullable(),
    backgroundImageSets: z.any().optional().nullable(),
    lastUpdatedBy: z.object({
      __typename: z.literal("User").optional(),
      _id: z.string().optional().nullable(),
      name: z.string().optional().nullable(),
      teams: z.array(
        z.object({
          __typename: z.literal("UsersTeams").optional(),
          team: z.string().optional().nullable(),
          manage: z.boolean().optional().nullable()
        }).nullable()
      ).optional().nullable()
    }).optional().nullable(),
    createdBy: z.object({
      __typename: z.literal("User").optional(),
      _id: z.string().optional().nullable(),
      name: z.string().optional().nullable(),
      teams: z.array(
        z.object({
          __typename: z.literal("UsersTeams").optional(),
          team: z.string().optional().nullable(),
          manage: z.boolean().optional().nullable()
        }).nullable()
      ).optional().nullable()
    }).optional().nullable(),
    adTemplate: z.object({
      __typename: z.literal("AdTemplate").optional(),
      market: z.object({
        __typename: z.literal("AdTemplateMarket").optional(),
        oddsButtonTemplate: z.string().optional().nullable()
      }).optional().nullable(),
      potentialWinnings: z.object({
        __typename: z.literal("PotentialWinnings").optional(),
        stake: z.number().optional().nullable(),
        currency: z.string().optional().nullable()
      }).optional().nullable(),
      team: z.object({
        __typename: z.literal("AdTemplateTeam").optional(),
        useAdditionalBrandingOptions: z.boolean().optional().nullable(),
        useCustomAssets: z.boolean().optional().nullable(),
        useHorseRacingSilks: z.boolean().optional().nullable(),
        useTeamBadges: z.boolean().optional().nullable(),
        useTeamColors: z.boolean().optional().nullable(),
        useTeamJerseys: z.boolean().optional().nullable(),
        useTeamBranding: z.boolean().optional().nullable(),
        badge: z.object({
          __typename: z.literal("AdTemplateBadge").optional(),
          borderColor: z.string().optional().nullable(),
          filters: z.array(
            z.object({
              __typename: z.literal("BadgeFilters").optional(),
              competitions: z.array(z.string().nullable()).optional().nullable(),
              operator: z.string().optional().nullable(),
              sports: z.array(z.string().nullable()).optional().nullable()
            }).nullable()
          ).optional().nullable(),
          leagueLogos: z.array(
            z.object({
              __typename: z.literal("LeagueLogosBadgeFilters").optional(),
              competitions: z.array(z.string().nullable()).optional().nullable(),
              operator: z.string().optional().nullable()
            }).nullable()
          ).optional().nullable()
        }).optional().nullable()
      }).optional().nullable()
    }).optional().nullable()
  }).optional().nullable()
});
var getBrandsListQuerySchema = z.object({
  __typename: z.literal("Query").optional(),
  brands: z.object({
    __typename: z.literal("Brands").optional(),
    edges: z.array(
      z.object({
        __typename: z.literal("BrandEdge").optional(),
        node: z.object({
          __typename: z.literal("Brand").optional(),
          _id: z.string().optional().nullable(),
          name: z.string().optional().nullable()
        }).optional().nullable()
      }).nullable()
    ).optional().nullable()
  }).optional().nullable()
});
var getTeamsListQuerySchema = z.object({
  __typename: z.literal("Query").optional(),
  teams: z.object({
    __typename: z.literal("Teams").optional(),
    edges: z.array(
      z.object({
        __typename: z.literal("TeamEdge").optional(),
        node: z.object({
          __typename: z.literal("Team").optional(),
          _id: z.string().optional().nullable(),
          name: z.string().optional().nullable()
        }).optional().nullable()
      }).nullable()
    ).optional().nullable()
  }).optional().nullable()
});
var getUserFontsQuerySchema = z.object({
  __typename: z.literal("Query").optional(),
  userFonts: z.object({
    __typename: z.literal("UserFontConnection").optional(),
    edges: z.array(
      z.object({
        __typename: z.literal("UserFontEdge").optional(),
        node: z.object({
          __typename: z.literal("UserFont").optional(),
          _id: z.string(),
          name: z.string(),
          family: z.string(),
          fontFamily: z.string(),
          url: z.string()
        }).optional().nullable()
      }).nullable()
    ).optional().nullable()
  }).optional().nullable()
});

// src/generated/creative-hub-api/graphql.ts
var graphql_exports2 = {};
__export(graphql_exports2, {
  AdTagMomentType: () => AdTagMomentType,
  AdTagStage: () => AdTagStage,
  BrandsDocument: () => BrandsDocument,
  ContentFilterDataSource: () => ContentFilterDataSource,
  CreateBrandDocument: () => CreateBrandDocument,
  DataSource: () => DataSource,
  EventStage: () => EventStage,
  FormatSelection: () => FormatSelection,
  GetBrandByIdDocument: () => GetBrandByIdDocument,
  GetBrandLogoPresignedUrlDocument: () => GetBrandLogoPresignedUrlDocument,
  GetBrandsByAdvertiserDocument: () => GetBrandsByAdvertiserDocument,
  GetFontFamiliesByOwnerDocument: () => GetFontFamiliesByOwnerDocument,
  ProcessingStatus: () => ProcessingStatus,
  SortOrder: () => SortOrder,
  UploadOneFontFamilyDocument: () => UploadOneFontFamilyDocument,
  UsageOptions: () => UsageOptions
});
var AdTagMomentType = /* @__PURE__ */ ((AdTagMomentType2) => {
  AdTagMomentType2["LiveGeneric"] = "live_generic";
  AdTagMomentType2["LiveGoalScored"] = "live_goal_scored";
  AdTagMomentType2["PostGeneric"] = "post_generic";
  AdTagMomentType2["PostWinner"] = "post_winner";
  AdTagMomentType2["PreGeneric"] = "pre_generic";
  return AdTagMomentType2;
})(AdTagMomentType || {});
var AdTagStage = /* @__PURE__ */ ((AdTagStage2) => {
  AdTagStage2["Live"] = "live";
  AdTagStage2["Post"] = "post";
  AdTagStage2["Pre"] = "pre";
  return AdTagStage2;
})(AdTagStage || {});
var ContentFilterDataSource = /* @__PURE__ */ ((ContentFilterDataSource2) => {
  ContentFilterDataSource2["SportsMoments"] = "SPORTS_MOMENTS";
  ContentFilterDataSource2["SportsOdds"] = "SPORTS_ODDS";
  return ContentFilterDataSource2;
})(ContentFilterDataSource || {});
var DataSource = /* @__PURE__ */ ((DataSource2) => {
  DataSource2["Casino"] = "CASINO";
  DataSource2["Nascar"] = "NASCAR";
  DataSource2["Sports"] = "SPORTS";
  DataSource2["SportsMoments"] = "SPORTS_MOMENTS";
  return DataSource2;
})(DataSource || {});
var EventStage = /* @__PURE__ */ ((EventStage2) => {
  EventStage2["Live"] = "LIVE";
  EventStage2["Post"] = "POST";
  EventStage2["Pre"] = "PRE";
  return EventStage2;
})(EventStage || {});
var FormatSelection = /* @__PURE__ */ ((FormatSelection2) => {
  FormatSelection2["Html"] = "HTML";
  FormatSelection2["Image"] = "IMAGE";
  return FormatSelection2;
})(FormatSelection || {});
var ProcessingStatus = /* @__PURE__ */ ((ProcessingStatus2) => {
  ProcessingStatus2["Completed"] = "COMPLETED";
  ProcessingStatus2["Failed"] = "FAILED";
  ProcessingStatus2["Idle"] = "IDLE";
  ProcessingStatus2["Processing"] = "PROCESSING";
  return ProcessingStatus2;
})(ProcessingStatus || {});
var SortOrder = /* @__PURE__ */ ((SortOrder2) => {
  SortOrder2["Asc"] = "asc";
  SortOrder2["Desc"] = "desc";
  return SortOrder2;
})(SortOrder || {});
var UsageOptions = /* @__PURE__ */ ((UsageOptions2) => {
  UsageOptions2["Display"] = "DISPLAY";
  UsageOptions2["Dooh"] = "DOOH";
  UsageOptions2["Other"] = "OTHER";
  return UsageOptions2;
})(UsageOptions || {});
var GetFontFamiliesByOwnerDocument = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "getFontFamiliesByOwner" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "advertiserId" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "getFontFamiliesByOwner" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "advertiserId" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "advertiserId" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "holdingId" } }, { "kind": "Field", "name": { "kind": "Name", "value": "fonts" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "variant" } }, { "kind": "Field", "name": { "kind": "Name", "value": "size" } }, { "kind": "Field", "name": { "kind": "Name", "value": "path" } }, { "kind": "Field", "name": { "kind": "Name", "value": "weight" } }, { "kind": "Field", "name": { "kind": "Name", "value": "style" } }, { "kind": "Field", "name": { "kind": "Name", "value": "stretch" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdAt" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdAt" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "updatedAt" } }] } }] } }] };
var UploadOneFontFamilyDocument = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "uploadOneFontFamily" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "data" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "FontFamilyUploadInput" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "uploadOneFontFamily" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "data" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "data" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "name" } }] } }] } }] };
var GetBrandLogoPresignedUrlDocument = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "getBrandLogoPresignedUrl" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "advertiserId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "Float" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "brandId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "fileName" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "fileType" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "getBrandLogoPresignedUrl" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "advertiserId" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "advertiserId" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "brandId" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "brandId" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "fileName" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "fileName" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "fileType" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "fileType" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "presignedUrl" } }, { "kind": "Field", "name": { "kind": "Name", "value": "logoPath" } }] } }] } }] };
var CreateBrandDocument = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "createBrand" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "name" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "advertiserId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "Float" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "logoPath" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "primaryColor" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "secondaryColor" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "fonts" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "BrandFontsInput" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "createBrand" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "name" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "name" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "advertiserId" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "advertiserId" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "logoPath" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "logoPath" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "primaryColor" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "primaryColor" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "secondaryColor" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "secondaryColor" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "fonts" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "fonts" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "advertiserId" } }, { "kind": "Field", "name": { "kind": "Name", "value": "holdingId" } }, { "kind": "Field", "name": { "kind": "Name", "value": "logoPath" } }, { "kind": "Field", "name": { "kind": "Name", "value": "logoUrl" } }, { "kind": "Field", "name": { "kind": "Name", "value": "primaryColor" } }, { "kind": "Field", "name": { "kind": "Name", "value": "secondaryColor" } }, { "kind": "Field", "name": { "kind": "Name", "value": "fonts" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "primary" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "fontFamilyId" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "secondary" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "fontFamilyId" } }] } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdAt" } }, { "kind": "Field", "name": { "kind": "Name", "value": "updatedAt" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdBy" } }, { "kind": "Field", "name": { "kind": "Name", "value": "updatedBy" } }] } }] } }] };
var GetBrandsByAdvertiserDocument = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "getBrandsByAdvertiser" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "advertiserId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "Float" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "getBrandsByAdvertiser" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "advertiserId" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "advertiserId" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "advertiserId" } }, { "kind": "Field", "name": { "kind": "Name", "value": "holdingId" } }, { "kind": "Field", "name": { "kind": "Name", "value": "logoPath" } }, { "kind": "Field", "name": { "kind": "Name", "value": "logoUrl" } }, { "kind": "Field", "name": { "kind": "Name", "value": "primaryColor" } }, { "kind": "Field", "name": { "kind": "Name", "value": "secondaryColor" } }, { "kind": "Field", "name": { "kind": "Name", "value": "fonts" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "primary" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "fontFamilyId" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "secondary" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "fontFamilyId" } }] } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdAt" } }, { "kind": "Field", "name": { "kind": "Name", "value": "updatedAt" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdBy" } }, { "kind": "Field", "name": { "kind": "Name", "value": "updatedBy" } }] } }] } }] };
var GetBrandByIdDocument = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "getBrandById" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "getBrandById" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "advertiserId" } }, { "kind": "Field", "name": { "kind": "Name", "value": "holdingId" } }, { "kind": "Field", "name": { "kind": "Name", "value": "logoPath" } }, { "kind": "Field", "name": { "kind": "Name", "value": "logoUrl" } }, { "kind": "Field", "name": { "kind": "Name", "value": "primaryColor" } }, { "kind": "Field", "name": { "kind": "Name", "value": "secondaryColor" } }, { "kind": "Field", "name": { "kind": "Name", "value": "fonts" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "primary" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "fontFamilyId" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "secondary" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "fontFamilyId" } }] } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdAt" } }, { "kind": "Field", "name": { "kind": "Name", "value": "updatedAt" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdBy" } }, { "kind": "Field", "name": { "kind": "Name", "value": "updatedBy" } }] } }] } }] };
var BrandsDocument = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "brands" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "advertiserIds" } }, "type": { "kind": "ListType", "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "Float" } } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "brands" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "advertiserIds" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "advertiserIds" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "advertiserId" } }, { "kind": "Field", "name": { "kind": "Name", "value": "holdingId" } }, { "kind": "Field", "name": { "kind": "Name", "value": "logoPath" } }, { "kind": "Field", "name": { "kind": "Name", "value": "logoUrl" } }, { "kind": "Field", "name": { "kind": "Name", "value": "primaryColor" } }, { "kind": "Field", "name": { "kind": "Name", "value": "secondaryColor" } }, { "kind": "Field", "name": { "kind": "Name", "value": "fonts" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "primary" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "fontFamilyId" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "secondary" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "fontFamilyId" } }] } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdAt" } }, { "kind": "Field", "name": { "kind": "Name", "value": "updatedAt" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdBy" } }, { "kind": "Field", "name": { "kind": "Name", "value": "updatedBy" } }] } }] } }] };

// graphql/creative-hub-api/brandkit-fonts.gql.ts
var brandkit_fonts_gql_exports = {};
__export(brandkit_fonts_gql_exports, {
  GET_ALL_FONTS_BY_OWNER: () => GET_ALL_FONTS_BY_OWNER,
  UPLOAD_ONE_FONT_FAMILY: () => UPLOAD_ONE_FONT_FAMILY
});

// src/generated/creative-hub-api/gql.ts
var documents = {
  "\n  query getFontFamiliesByOwner($advertiserId: String) {\n    getFontFamiliesByOwner(advertiserId: $advertiserId) {\n      id\n      holdingId\n      fonts {\n        variant\n        size\n        path\n        weight\n        style\n        stretch\n        createdAt\n      }\n      createdAt\n      name\n      updatedAt\n    }\n  }\n": GetFontFamiliesByOwnerDocument,
  "\n  mutation uploadOneFontFamily($data: FontFamilyUploadInput!) {\n    uploadOneFontFamily(data: $data) {\n      name\n    }\n  }\n": UploadOneFontFamilyDocument,
  "\n  mutation getBrandLogoPresignedUrl(\n    $advertiserId: Float!\n    $brandId: String!\n    $fileName: String!\n    $fileType: String!\n  ) {\n    getBrandLogoPresignedUrl(\n      advertiserId: $advertiserId\n      brandId: $brandId\n      fileName: $fileName\n      fileType: $fileType\n    ) {\n      presignedUrl\n      logoPath\n    }\n  }\n": GetBrandLogoPresignedUrlDocument,
  "\n  mutation createBrand(\n    $id: String\n    $name: String!\n    $advertiserId: Float!\n    $logoPath: String\n    $primaryColor: String!\n    $secondaryColor: String!\n    $fonts: BrandFontsInput\n  ) {\n    createBrand(\n      id: $id\n      name: $name\n      advertiserId: $advertiserId\n      logoPath: $logoPath\n      primaryColor: $primaryColor\n      secondaryColor: $secondaryColor\n      fonts: $fonts\n    ) {\n      id\n      name\n      advertiserId\n      holdingId\n      logoPath\n      logoUrl\n      primaryColor\n      secondaryColor\n      fonts {\n        primary {\n          fontFamilyId\n        }\n        secondary {\n          fontFamilyId\n        }\n      }\n      createdAt\n      updatedAt\n      createdBy\n      updatedBy\n    }\n  }\n": CreateBrandDocument,
  "\n  query getBrandsByAdvertiser($advertiserId: Float!) {\n    getBrandsByAdvertiser(advertiserId: $advertiserId) {\n      id\n      name\n      advertiserId\n      holdingId\n      logoPath\n      logoUrl\n      primaryColor\n      secondaryColor\n      fonts {\n        primary {\n          fontFamilyId\n        }\n        secondary {\n          fontFamilyId\n        }\n      }\n      createdAt\n      updatedAt\n      createdBy\n      updatedBy\n    }\n  }\n": GetBrandsByAdvertiserDocument,
  "\n  query getBrandById($id: String!) {\n    getBrandById(id: $id) {\n      id\n      name\n      advertiserId\n      holdingId\n      logoPath\n      logoUrl\n      primaryColor\n      secondaryColor\n      fonts {\n        primary {\n          fontFamilyId\n        }\n        secondary {\n          fontFamilyId\n        }\n      }\n      createdAt\n      updatedAt\n      createdBy\n      updatedBy\n    }\n  }\n": GetBrandByIdDocument,
  "\n  query brands($advertiserIds: [Float!]) {\n    brands(advertiserIds: $advertiserIds) {\n      id\n      name\n      advertiserId\n      holdingId\n      logoPath\n      logoUrl\n      primaryColor\n      secondaryColor\n      fonts {\n        primary {\n          fontFamilyId\n        }\n        secondary {\n          fontFamilyId\n        }\n      }\n      createdAt\n      updatedAt\n      createdBy\n      updatedBy\n    }\n  }\n": BrandsDocument
};
function gql2(source) {
  return documents[source] ?? {};
}

// graphql/creative-hub-api/brandkit-fonts.gql.ts
var GET_ALL_FONTS_BY_OWNER = gql2(
  /* GraphQL */
  `
  query getFontFamiliesByOwner($advertiserId: String) {
    getFontFamiliesByOwner(advertiserId: $advertiserId) {
      id
      holdingId
      fonts {
        variant
        size
        path
        weight
        style
        stretch
        createdAt
      }
      createdAt
      name
      updatedAt
    }
  }
`
);
var UPLOAD_ONE_FONT_FAMILY = gql2(
  /* GraphQL */
  `
  mutation uploadOneFontFamily($data: FontFamilyUploadInput!) {
    uploadOneFontFamily(data: $data) {
      name
    }
  }
`
);

// graphql/creative-hub-api/brands.gql.ts
var brands_gql_exports = {};
__export(brands_gql_exports, {
  CREATE_BRAND: () => CREATE_BRAND,
  FETCH_ALL_BRANDS: () => FETCH_ALL_BRANDS,
  GET_BRANDS_BY_ADVERTISER: () => GET_BRANDS_BY_ADVERTISER,
  GET_BRAND_BY_ID: () => GET_BRAND_BY_ID,
  GET_BRAND_LOGO_PRESIGNED_URL: () => GET_BRAND_LOGO_PRESIGNED_URL
});
var GET_BRAND_LOGO_PRESIGNED_URL = gql2(
  /* GraphQL */
  `
  mutation getBrandLogoPresignedUrl(
    $advertiserId: Float!
    $brandId: String!
    $fileName: String!
    $fileType: String!
  ) {
    getBrandLogoPresignedUrl(
      advertiserId: $advertiserId
      brandId: $brandId
      fileName: $fileName
      fileType: $fileType
    ) {
      presignedUrl
      logoPath
    }
  }
`
);
var CREATE_BRAND = gql2(
  /* GraphQL */
  `
  mutation createBrand(
    $id: String
    $name: String!
    $advertiserId: Float!
    $logoPath: String
    $primaryColor: String!
    $secondaryColor: String!
    $fonts: BrandFontsInput
  ) {
    createBrand(
      id: $id
      name: $name
      advertiserId: $advertiserId
      logoPath: $logoPath
      primaryColor: $primaryColor
      secondaryColor: $secondaryColor
      fonts: $fonts
    ) {
      id
      name
      advertiserId
      holdingId
      logoPath
      logoUrl
      primaryColor
      secondaryColor
      fonts {
        primary {
          fontFamilyId
        }
        secondary {
          fontFamilyId
        }
      }
      createdAt
      updatedAt
      createdBy
      updatedBy
    }
  }
`
);
var GET_BRANDS_BY_ADVERTISER = gql2(
  /* GraphQL */
  `
  query getBrandsByAdvertiser($advertiserId: Float!) {
    getBrandsByAdvertiser(advertiserId: $advertiserId) {
      id
      name
      advertiserId
      holdingId
      logoPath
      logoUrl
      primaryColor
      secondaryColor
      fonts {
        primary {
          fontFamilyId
        }
        secondary {
          fontFamilyId
        }
      }
      createdAt
      updatedAt
      createdBy
      updatedBy
    }
  }
`
);
var GET_BRAND_BY_ID = gql2(
  /* GraphQL */
  `
  query getBrandById($id: String!) {
    getBrandById(id: $id) {
      id
      name
      advertiserId
      holdingId
      logoPath
      logoUrl
      primaryColor
      secondaryColor
      fonts {
        primary {
          fontFamilyId
        }
        secondary {
          fontFamilyId
        }
      }
      createdAt
      updatedAt
      createdBy
      updatedBy
    }
  }
`
);
var FETCH_ALL_BRANDS = gql2(
  /* GraphQL */
  `
  query brands($advertiserIds: [Float!]) {
    brands(advertiserIds: $advertiserIds) {
      id
      name
      advertiserId
      holdingId
      logoPath
      logoUrl
      primaryColor
      secondaryColor
      fonts {
        primary {
          fontFamilyId
        }
        secondary {
          fontFamilyId
        }
      }
      createdAt
      updatedAt
      createdBy
      updatedBy
    }
  }
`
);
export {
  brands_gql_exports as BrandKitBrandsGQL,
  brandkit_fonts_gql_exports as BrandKitGQL,
  graphql_exports as ConsoleAPIGraph,
  graphql_schema_exports as ConsoleAPIGraphSchema,
  graphql_exports2 as CreativeHubTypes
};
